<template>
  <div class="list-comment-header-group">
    <div
      v-for="column in columns"
      :key="column.column_id"
      class="list-comment-sub-header"
      :class="isSortActive(column) ? 'data-table-sort-active' : ''"
      @click="column.is_numeric_only == 1 ? sortColumn(column) : null"
    >
      <div class="list-comment-header-label">リスト内コメント</div>
      <el-tooltip :content="displayTitle(column)" placement="top" :disabled="!isTitleTruncated(column)">
        <span
          class="list-comment-header-title"
          :class="column.is_numeric_only == 1 ? 'pointer data-table-underline' : ''"
        >{{ truncatedTitle(column) }}</span>
      </el-tooltip>
      <font-awesome-icon
        v-if="column.is_numeric_only == 1 && isSortActive(column)"
        :icon="['fas', sort_order == 'asc' ? 'arrow-up' : 'arrow-down']"
        style="margin-left: 3px"
      />
      <div v-if="column.column_type === 'normal' && editable" class="list-comment-header-actions">
        <i class="el-icon-edit pointer" @click.stop="$emit('edit-title', column)"></i>
        <i
          v-if="canDeleteColumn"
          class="el-icon-delete pointer"
          @click.stop="$emit('delete-column', column)"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import { LIST_COMMENT_MIN_NORMAL_COLUMNS } from "@/utils/listCommentConst";

export default {
  name: "listCommentHeaderGroup",
  props: {
    columns: { type: Array, default: () => [] },
    sort_key: { type: String, default: "" },
    sort_order: { type: String, default: "desc" },
    editable: { type: Boolean, default: true },
    normalColumnCount: { type: Number, default: 0 },
  },
  computed: {
    canDeleteColumn() {
      return this.editable && this.normalColumnCount > LIST_COMMENT_MIN_NORMAL_COLUMNS;
    },
  },
  methods: {
    displayTitle(column) {
      if (column.column_type === "post_url") {
        return "投稿URL";
      }
      return column.title || "";
    },
    truncatedTitle(column) {
      const title = this.displayTitle(column);
      if (title.length === 0) {
        return " ";
      }
      if (title.length <= 8) {
        return title;
      }
      return title.substring(0, 8) + "...";
    },
    isTitleTruncated(column) {
      return this.displayTitle(column).length > 8;
    },
    sortColumnKey(column) {
      return "comment_column_" + column.column_id;
    },
    isSortActive(column) {
      return this.sort_key === this.sortColumnKey(column);
    },
    sortColumn(column) {
      this.$emit("sort-column", this.sortColumnKey(column));
    },
  },
};
</script>

<style scoped>
.list-comment-header-group {
  display: flex;
  flex-flow: row;
  align-items: stretch;
  width: max-content;
  min-width: 100%;
}
.list-comment-sub-header {
  min-width: 140px;
  width: 140px;
  max-width: 140px;
  flex-shrink: 0;
  position: relative;
  display: flex;
  flex-flow: column;
  justify-content: center;
  padding: 4px;
  box-sizing: border-box;
}
.list-comment-header-label {
  font-size: 11px;
  color: #999;
  line-height: 1.2;
  margin-bottom: 2px;
}
.list-comment-header-title {
  font-size: 12px;
  line-height: 1.3;
  word-break: break-all;
}
.list-comment-header-actions {
  display: flex;
  gap: 6px;
  margin-top: 4px;
  font-size: 12px;
  color: #999;
}
</style>
